import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'

//  web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAl5RV8LLFgl2ALUHBGCvQ1LzsiHc3jieQ",
  authDomain: "smart-brain-78060.firebaseapp.com",
  projectId: "smart-brain-78060",
  storageBucket: "smart-brain-78060.appspot.com",
  messagingSenderId: "956291307596",
  appId: "1:956291307596:web:8c09885c24814e07733ce9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app)
